<template>
  <div class="c-main">
    <h2 class="c-title c-title--page">{{$t('user.add')}}</h2>
    <form action="#" class="c-main--flex-1 u-margin-bottom-large">
      <div class="o-layout">
        <div class="o-layout__item u-1-of-2-at-small">
          <sceEmailField v-model="email" name="email" label="email"
                         v-validate data-vv-rules="required|min:3" :class="{'is-invalid': errors.has('email')}"/>
        </div>
        <div class="o-layout__item u-1-of-2-at-small">
          <sceTextField v-model="username" name="username" label="username"
                        v-validate data-vv-rules="required|min:3" :class="{'is-invalid': errors.has('username')}"/>
        </div>
        <div class="o-layout__item u-1-of-2-at-small">
          <sceTextField v-model="userFullname" name="userFullname" label="fullname"
                        v-validate data-vv-rules="required|min:3" :class="{'is-invalid': errors.has('userFullname')}"/>
        </div>
        <div class="o-layout__item u-1-of-2-at-small">
          <sceTextField v-model="password" name="password" label="password"
                        v-validate data-vv-rules="required|min:6" :class="{'is-invalid': errors.has('password')}"/>
        </div>
      </div>
    </form>
    <footer class="c-footer c-footer--bottom-sticky c-footer--bottom-sticky-fixed-height o-layout">
      <div class="o-layout__item u-1-of-2-at-tiny">
      </div>
      <div class="o-layout__item u-1-of-2-at-tiny u-text-right">
        <button class="c-button c-button--primary c-button--large" v-on:click.prevent="submit()">
          {{$t('save')}}
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
  import form from '@/lib/form'

  export default {
    name: "AddOrganisation",
    languages: form.idNamePairs(require('/locales/index'), 'languages.'),
    data: function() {
      return {
        name: null,
        username: null,
        userFullname: null,
        email: null,
        locale: 'en',
        countryId: 'country-bel',
        password: null,
      }
    },
    computed: {
      countries: function() {
        return this.$store.state.events.countries
      },
    },
    methods: {
      submit: function() {
        this.$validator.validateAll().then(() => {
          if (!this.errors.any()) {
            this.$notify.saveAsync(
                this.$t('menu.userProfile'),
                this.$store.dispatch('user.add', {
                  username: this.username,
                  email: this.email,
                  password: this.password,
                  name: this.userFullname,
                }),
                () => {
                  this.$navigation.goto({name: 'admin.users'})
                }
            );
          }
        });
      },
    },
  }
</script>

<style scoped>

</style>
